import React, { JSXElementConstructor, ReactElement } from 'react';
import { render } from 'react-dom';
import axios from 'axios';
import { Component } from '@verndale/core';
import ProductSampleSelection from './productSampleSelection';
import ProductGuideOverlay from './react/productGuideOverlay';

export type Filter = {
  SKUPropertyValue: string;
  Text: string;
  SKUPropertyName: string;
  Label: string;
};

export type TableAttribute = {
  SKUPropertyName: string;
  Label: string;
};

export type SKU = {
  [key: string]: string;
};

export type DataType = {
  Filters: Filter[];
  TableAttributes: TableAttribute[];
  Skus: SKU[];
};

const reactModule = (Component: ReactElement, nodeList: HTMLElement[], data: DataType ) => {
  nodeList.forEach((node) => render((
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Component {...node.dataset} data={data} /> as JSXElementConstructor), node));
};

class ProductSample extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.loadData();
  }

  setupDefaults() {
    this.dom = {
      sampleSelector: this.el.querySelector<HTMLElement>(
        '.product-detail__sample-selection'
      ),
      productOverlayButton: this.el.querySelector<HTMLElement>('.product-detail__footer-button-container')
    };
  }

  async loadData() {
    try {
      const { data } = await axios.get(this.el.dataset.endpoint as string);
      this.initModules(data);

    } catch (error) {
      console.log(error);
    }
  }

  initModules(data: DataType) {
    if (this.dom.sampleSelector) {
      new ProductSampleSelection(this.dom.sampleSelector as HTMLElement, data);
    }

    if (this.dom.productOverlayButton) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      reactModule(ProductGuideOverlay, [this.dom.productOverlayButton], data);
    }
  }
}

export default ProductSample;
